import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { injectIntl } from 'react-intl';
import { untouch } from 'redux-form';

import createValidator from 'shared/utils/formValidator';
import { PHONE_NUMBER_LENGTH } from 'modules/auth/actions/loginForm';
import {
  localErrorMessagesMap,
  EMPTY_TEXT_FIELD,
  INVALID_POLICY_ID_LOCAL,
  INVALID_PHONE_NUMBER_LOCAL,
} from 'modules/auth/constants/localErrorCodes';
import { loginAttributeLabels } from './attributeLabels';

import PrimaryLoginForm from './PrimaryLoginForm';

const form = 'PRIMARY_LOGIN_FORM';

const mapStateToProps = state => ({
  form,
  loginMethod: state.auth.organizations.selectedOrganizationPatientLoginMethod,
  loginConfig: state.auth.organizations.loginConfig,
});

export default compose(
  injectIntl,
  connect(mapStateToProps, { untouch }),
  withHandlers({
    validate: ({ intl, loginConfig }) => (formData) => {
      const rules = {
        externalId: ['required', `regex:/${ loginConfig.externalIdRegexp }/`],
        phoneNumber: ['required', `max:${ PHONE_NUMBER_LENGTH }`],
      };

      return createValidator(rules, {
        'required.externalId': localErrorMessagesMap[EMPTY_TEXT_FIELD],
        'required.phoneNumber': localErrorMessagesMap[EMPTY_TEXT_FIELD],
        'regex.externalId': localErrorMessagesMap[INVALID_POLICY_ID_LOCAL],
        'invalid.phoneNumber': localErrorMessagesMap[INVALID_PHONE_NUMBER_LOCAL],
      }, { ...loginAttributeLabels, externalId: loginConfig.externalIdName })(formData, { intl });
    },
  }),
)(PrimaryLoginForm);
